import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
    } = config;
    this.accordionSelector = accordions;
    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;
    if (this.accordions && this.accordions.length !== 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      el.addEventListener('click', (e) => {
        if (el.classList.contains('active')) {
          Helper.slideClose(el.nextElementSibling);
          el.classList.remove('active');
        } else {
          el.classList.add('active');
          Helper.slideOpen(el.nextElementSibling, true);
        }
      });
    });

    if (window.location.hash.includes('note-')) {
      // open note
      const accordion = document.querySelector(window.location.hash + ' .ns-accordion__head');
      console.log(window.location.hash)
      if (accordion) {
        accordion.click()

        setTimeout(() => {
          let offsetPosition = accordion.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: (offsetPosition - 90),
            behavior: "smooth"
          });
        }, 200);

      }
    } else {
      if(!window.location.hash || window.location.hash.trim() == '') return;
      const hashTarget = document.querySelector(window.location.hash);
      const closestAccoridon = hashTarget.closest('.ns-cv, .ns-sdg-accordion, .ns-accordion, ns-accordion');
      if (closestAccoridon) {
        (closestAccoridon.querySelector(this.accordionSelector)).click();


        setTimeout(() => {
          let offsetPosition = hashTarget.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: (offsetPosition - 90),
            behavior: "smooth"
          });
        }, 200);
      }

    }
  }

}

export default Accordion;
